// extracted by mini-css-extract-plugin
export default {"download_section":"download_download_section__cP1EW","button_download":"download_button_download__P3AvC"};